import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'formik';

import './ErrorCustom.scss';

/**
 * custom error
 * @constructor
 * @param error
 */
const ErrorCustom = ({ error }) => (error && error !== ' ' ? <div className="error">{error}</div> : <></>);

ErrorCustom.propTypes = {
  error: PropTypes.string,
};

ErrorCustom.defaultProps = {
  error: null,
};

export default connect(ErrorCustom);
